<!--
 * @Description: 我的值班 列表页
 * @Author: PF
 * @Date: 2023-08-31 16:30:09.638
 * @LastEditors: PF
 * @LastEditTime: 2025-05-27 12:00:33
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">我的值班</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-select placeholder="值班类别" v-model="dataGrid.parms.zblbid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in zblbData" :key="item.id" :label="item.zblbmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-time-picker v-model="zbsj" is-range range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" format="HH:mm" value-format="HH:mm" clearable @change="bindTable()" />
              </el-form-item>
              <el-form-item>
                <el-select placeholder="值班日志状况" v-model="dataGrid.parms.zbrbzk" clearable filterable @change="bindTable()">
                  <el-option v-for="item in zbrzzkData.listZhuangTai" :key="item.value" :label="item.name" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-button @click="zbb='ri';bindTable()">本日值班表</el-button>
              <el-button @click="zbb='zhou';bindTable()">本周值班表</el-button>
              <el-button @click="zbb='yue';bindTable()">本月值班表</el-button>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button class="w200" type="info" @click="exportData">
                <el-icon class="el-icon--left">
                  <DocumentCopy />
                </el-icon>导出
              </el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="值班日期" prop="zbrq" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="值班类别" prop="zblbmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="值班内容名称" prop="zbnrmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="值班位置" prop="zbwz" align="center" show-overflow-tooltip />
              <el-table-column label="值班时段" prop="zbsd" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-for="(item, index) in zbsdData" :key="index">
                    <span v-if="scope.row.zbsd === item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="值班时间" prop="zbkssj" align="center" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.zbkssj }}
                  <span v-if="scope.row.zbkssj && scope.row.zbjssj">至</span>
                  {{ scope.row.zbjssj }}
                </template>
              </el-table-column>
              <el-table-column label="值班日志状况" prop="zbrbzk" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-for="(item, index) in zbrzzkData.listZhuangTai" :key="index">
                    <span v-if="scope.row.zbrbzk === item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="值班状态" prop="zbzt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-for="(item, index) in zbrbzkData.listZhuangTai" :key="index">
                    <span v-if="scope.row.zbzt === item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" fixed="right" align="center">
                <template #default="scope">
                  <el-button v-if="scope.row.zbzt===zbrbzkData.yzb && scope.row.zbrbzk===zbrzzkData.wsc" link type="primary" @click="openTianBaoRiZhi=true; row={dbgzid: scope.row.id}">填报日志</el-button>
                  <el-button v-if="scope.row.zbzt===zbrbzkData.wzb" link type="primary" @click="openShenQingTiaoBan=true; row=scope.row">申请调班</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <tianbaorizhi v-if="openTianBaoRiZhi" v-model:openTianBaoRiZhi="openTianBaoRiZhi" :row="row" @ReturnData="bindTable" />
  <shenqingtiaoban v-if="openShenQingTiaoBan" v-model:openShenQingTiaoBan="openShenQingTiaoBan" :row="row" @ReturnData="bindTable" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, loadSelect, exportExcel, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import tianbaorizhi from '@/pages/bangong/zhibanguanli/wodezhiban/tianbaorizhi.vue'
import shenqingtiaoban from '@/pages/bangong/zhibanguanli/wodezhiban/shenqingtiaoban.vue'

const props = defineProps({
  open: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['openReturn', 'ReturnData'])

// 加载 值班类别 下拉框
const zblbData = ref([])
// 加载 值班内容 下拉框
const zbnrData = ref([])
// 加载 值班时段 下拉框
const zbsdData = ref([])
// 加载 值班状况 下拉框
const zbrbzkData = ref({ listZhuangTai: [] })
// 加载 值班日志状况 下拉框
const zbrzzkData = ref({ listZhuangTai: [] })

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'zbrq', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})

const zbb = ref()
const zbsj = ref([])
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.zblbid = dataGrid.value.parms.zblbid || undefined
  dataGrid.value.parms.zbrbzk = dataGrid.value.parms.zbrbzk || undefined
  dataGrid.value.parms.zbkssj = zbsj.value ? zbsj.value[0] : undefined
  dataGrid.value.parms.zbjssj = zbsj.value ? zbsj.value[1] : undefined
  let url = '/api/v2/bangong/zhibanrenyuanjilu/wodepagelist'
  switch (zbb.value) {
    case 'ri':
      url = '/api/v2/bangong/zhibanrenyuanjilu/wodezhibanjiludantian'
      break
    case 'zhou':
      url = '/api/v2/bangong/zhibanrenyuanjilu/wodezhibanjiluzhou'
      break
    case 'yue':
      url = '/api/v2/bangong/zhibanrenyuanjilu/wodezhibanjiluyue'
      break
    default:
      url = '/api/v2/bangong/zhibanrenyuanjilu/wodepagelist'
      break
  }
  loadList({
    url: url,
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const row = ref()
const openList = ref(false)
const openTianBaoRiZhi = ref(false)
const openShenQingTiaoBan = ref(false)

// Excel导出
const exportData = async () => {
  dataGrid.value.parms.zblbid = dataGrid.value.parms.zblbid || undefined
  dataGrid.value.parms.zblbid = dataGrid.value.parms.zblbid || undefined
  dataGrid.value.parms.zbkssj = zbsj.value ? zbsj.value[0] : undefined
  dataGrid.value.parms.zbjssj = zbsj.value ? zbsj.value[1] : undefined
  dataGrid.value.orderBy.prop = 'zbrq'
  exportExcel('/api/v2/bangong/zhibanrenyuanjilu/wodeexport', dataGrid.value)
}

watch(
  () => props.open,
  () => {
    if (props.open === 'wodezhiban') {
      openList.value = true
      loadSelect({
        url: '/api/v2/bangong/zhibanleibie/list',
        data: zblbData,
        order: 'sx',
        sort: 'asc'
      })
      loadSelect({
        url: '/api/v2/bangong/zhibanneirong/list',
        data: zbnrData,
        parms: { zt: 2 },
        order: 'zbnrmc',
        sort: 'asc'
      })
      loadSelect({
        url: '/api/v2/bangong/zhibanneirong/zhibanshiduan',
        data: zbsdData
      })
      loadSelect({
        url: '/api/v2/bangong/zhibanrenyuanjilu/zhibanzhuangtai',
        data: zbrbzkData
      })
      loadSelect({
        url: '/api/v2/bangong/zhibanrenyuanjilu/zhibanrizhizhuangtai',
        data: zbrzzkData
      })
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
